import { useReceptionFailedMessage, type ErrorMessage } from "./useReceptionFailedMessage";
import type { ErrorResolverKey } from "~/utils/error";

/**
 * エラーメッセージをresolverKeyで解決する
 */
export const useErrorMessageResolver = (
  resolverKey: ErrorResolverKey,
  language: string,
  t: (k: string) => string
): ErrorMessage => {
  const receptionFailed = useReceptionFailedMessage(language, t);

  if (resolverKey === "RECEPTION_FAILED") {
    return receptionFailed;
  }

  if (resolverKey === "NO_CALL_DESTINATION") {
    return {
      title: t("noCallDestination.title"),
      content: t("noCallDestination.content"),
    };
  }

  if (resolverKey === "TARGET_DATA_NOT_FOUND") {
    return {
      title: t("failedAppointment.title"),
      content: t("failedAppointment.content"),
    };
  }

  return null;
};
